<template>
  <div class="app-container">
    <div class="order-btn">
      <vxe-button @click="returnFun()">返回</vxe-button>
    </div>
    <a-divider/>
    <div class="orderFormLine">订单信息</div>
    <div class="budgetBox">
      <a-form ref="orderForm" class="UniformCss" :inline="true" :model="order" label-width="100px">
        <a-row>
          <a-col :span="4">
            <a-form-item label="订单编号" prop="applyOrderCode">
              <a-input v-model="order.applyOrderCode" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="申领部门" prop="orgName">
              <a-input v-model="order.orgName" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="申领人" prop="applyMan">
              <a-input v-model="order.applyMan" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="申领日期" prop="applyTime">
              <a-input v-model="order.applyTime" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="订单总项数" prop="orderMaterialCount">
              <a-input v-model="order.orderMaterialCount" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="订单总数量" prop="orderNums">
              <a-input v-model="order.orderNums" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="订单总金额" prop="orderTotalSums">
              <a-input v-model="order.orderTotalSums" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="审批数量" prop="approveNums">
              <a-input v-model="order.approveNums" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="审批总金额">
              <a-input v-model="order.approveTotalSums" :disabled="true" />
            </a-form-item>
          </a-col>
          <!-- <a-col :span="6">
            <a-form-item label="审批意见" prop="approveInfo">
              <a-input v-model="order.approveInfo" :disabled="true" />
            </a-form-item>
          </a-col> -->
          <!-- <a-col :span="6">
            <a-form-item label="领料人" prop="drawMan">
              <a-input v-model="order.drawMan" :disabled="true" />
            </a-form-item>
          </a-col> -->
          <!-- <a-col :span="6">
            <a-form-item label="领取用途" prop="drawFor">
              <a-input v-model="order.drawFor" :disabled="true" />
            </a-form-item>
          </a-col> -->
          <!-- <a-col :span="6">
            <a-form-item label="领用部门" prop="drawOrz">
              <a-input v-model="order.drawOrz" :disabled="true" />
            </a-form-item>
          </a-col> -->
          <a-col :span="4">
            <a-form-item label="收货人" prop="receiverName">
              <a-input v-model="order.receiverName" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="收货人联系方式" prop="receivePhone">
              <a-input v-model="order.receivePhone" :disabled="true" />
            </a-form-item>
          </a-col>
          <!-- <a-col :span="6">
            <a-form-item label="收货地区">
              <a-input v-model="order.receiveArea" disabled />
            </a-form-item>
          </a-col> -->
          <a-col :span="4">
            <a-form-item label="收货地址">
              <a-input v-model="order.address" disabled />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="orderFormLine">物料信息</div>
    <div>
      <vxe-table
        :data="materialList"
        border
        style="width: 100%"
        show-header-overflow
        show-overflow
        :header-cell-style="{background:'#eef1f6'}"
      >
        <vxe-table-column field="materialCode" title="物料号" width="150" align="center" />
        <vxe-table-column field="materialName" title="物料名称" width="250" align="center" />
        <vxe-table-column field="storage" title="库存量" width="90" align="center" />
        <vxe-table-column field="price" title="申领价" width="90" align="center" />
        <vxe-table-column field="nums" title="申领数量" width="90" align="center" />
        <vxe-table-column field="totalSums" title="申领总金额" width="90" align="center" />
        <vxe-table-column field="approveNums" title="审批数量" width="90" align="center" />
        <vxe-table-column field="approveTotalSums" title="审批总金额" width="90" align="center" />
        <!-- <vxe-table-column field="receiveNums" title="收货数量" width="100" align="center" />
        <vxe-table-column field="receiveTime" title="收货时间" width="150" align="center" />
        <vxe-table-column field="receiveMan" title="收货确认人" width="100" align="center" />
        <vxe-table-column field="caption" title="物料说明" width="100" align="center" />-->
        <vxe-table-column field="applyRemarks" title="申领备注" width="160" align="center" />
        <vxe-table-column title="操作" align="center" fixed="right" width="100">
          <template  #default="{ row }">
            <a-button size="small" type="link" @click="detailFun(row)">查看</a-button>
          </template>
        </vxe-table-column>
      </vxe-table>
      <ApproveMaterialDialog :visible.sync="dialogVisible" :orderMaterial.sync="rowMaterial" :pictures="picList" :isdetail="true" @close="close" />
    </div>

    <div>
      <el-collapse v-model="collapseNumber" class="collapse-box" style="margin-bottom:10px">
        <el-collapse-item class="collapseItem" title="提报审核历史" name="default">
          <el-table :data="findHistTasksData" :loading="approveLoading" border stripe style="width: 100%">
            <el-table-column prop="displayName" label="审核部门" />
            <el-table-column prop="operatorName" label="审核人" />
            <el-table-column prop="finishTime" label="审核时间" />
            <el-table-column prop="amounts" label="申请费用(元)" align="right">
              <template #default="{ row }">
                <span v-if="row.amounts">
                  {{ row.amounts | toThousandNumFilter }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="approveCost" label="审核费用(元)" align="right">
              <template #default="{ row }">
                <span v-if="row.approveCost">
                  {{ row.approveCost | toThousandNumFilter }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="operateType" label="操作类型" />
            <el-table-column prop="approveMsg" label="审核意见" />
          </el-table>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import { getOrderById, findList4MaterialApply, getMaterialById, getImgs, findAddressListAll} from '@/api/material'
import ApproveMaterialDialog from './components/ApproveMaterialDialog.vue'
import { setInitImg } from '@/utils/Picture/transferFile'
import { findTaskInfos, findDisTaskInfos } from '@/api/wf_process.js'
export default {
  name: 'ApplyOrderDetail',
  components: {
    ApproveMaterialDialog
  },
  computed: {
    ...mapGetters('account', ['user']),
  },
  data() {
    return {
      collapseNumber: 'default',
      findHistTasksData: [],
      approveLoading: false,
      order: {},
      materialList: [],
      dialogVisible: false,
      rowMaterial: {},
      picList: [],
      receiveAddressList: [],
      // 用于用户查询（与审核页保持一致结构1）
      factor: { code: '', symbol: '', values: '' },
      listQuery: { page: 1, limit: 1, importance: undefined, domain: 'center', title: undefined, type: undefined, conditions: [], sort: '+id' }
    }
  },
  created() {
    if (this.$route.params.id) {
      this.order.id = this.$route.params.id
      // 仅拉取订单+明细+历史，不再做任何收货人兜底覆盖
      // this.findAddressListByUserNo()
      this.findAddressListAll()
      this.getOrderById()
      this.getOrderlDetail()
      this.viewApproveDetail()
    }
  },
  activated() {
    // 组件被 keep-alive 缓存时，返回本页也能及时回填收货人
    this.ensureReceiverName()
  },
  watch: {
    'order._receiverKey'() {
      this.ensureReceiverName()
    },
    receiveAddressList() {
      this.ensureReceiverName()
    },
    findHistTasksData() {
      this.ensureReceiverName()
    }
  },
  methods: {

    async findAddressListAll() {
      const params = {
      }
      await findAddressListAll(params).then(res => {
        this.receiveAddressList = Array.isArray(res.data) ? res.data : []
        // 地址簿到位后立即尝试映射姓名
        this.ensureReceiverName()
      })
    },

    // 将收货人ID映射为姓名：优先地址簿(recipientName) -> 后端姓名(receiverName) -> 用户接口 -> 审批历史
    ensureReceiverName() {
      if (!this.order) return
      const rKey = this.order._receiverKey
      // const rKey = this.order.receiveId || this.order.receiver || this.order._receiverKey

      if (!rKey) return
      // 1) 后端直接给的姓名（标准字段）
      if (this.order.receiverName) return

      // 2) 地址簿映射
      if (Array.isArray(this.receiveAddressList) && this.receiveAddressList.length) {
        const hit = this.receiveAddressList.find(it => String(it.id) === String(rKey))
        if (hit && hit.recipientName) {
          this.order.receiverName = hit.recipientName
          return
        }
      }
    },

    
    // 从审核历史回填审批意见（若后端未返回）
    fillApproveInfoFromHistory() {
      if (!this.order) return
      if (!this.order.approveInfo && Array.isArray(this.findHistTasksData) && this.findHistTasksData.length) {
        const last = this.findHistTasksData[this.findHistTasksData.length - 1]
        if (last && last.approveMsg) {
          this.order.approveInfo = last.approveMsg
        }
      }
    },
    getOrderById() {
      getOrderById(this.order.id).then(res => {
        if (res.code === 1) {
          this.order = res.data
          // this.order = res.data || this.order
      console.log(this.order,'this.order1');
      console.log(res.data.receiverName, 'this.order1.receiverName after mapped')

      if (res.data && res.data.receiverName) this.order.receiverName = res.data.receiverName
      this.order._receiverKey = this.order.receiveId || this.order.receiver || ''
      this.ensureReceiverName()
      this.$nextTick(() => {
      console.log(this.order.receiverName, 'receiverName after mapped')
      })
          // 标准化字段：优先后端姓名
          // if (res.data && res.data.receiverName) this.order.receiverName = res.data.receiverName
          // this.order._receiverKey = this.order.receiveId || this.order.receiver || ''
          // 订单返回后尝试一次姓名映射
          // this.ensureReceiverName()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    
    // async findAddressListByUserNo() {
    //   const params = {
    //     userNo: this.user.userNo,
    //     isAdmin: this.user.mainRoleName == '系统管理员' ? 1 : 0
    //   }
    //   await findAddressListByUserNo(params).then(res => {
    //     this.receiveAddressList = Array.isArray(res.data) ? res.data : []
    //     console.log(this.receiveAddressList, 'this.receiveAddressList')
    //     // 地址簿到位后立即尝试映射姓名
    //     this.ensureReceiverName()
    //   })
    // },
    getOrderlDetail() {
      const data = { orderId: Number(this.order.id) }
      findList4MaterialApply(data).then(res => {
        if (res.code === 1) {
          this.materialList = res.data.list
          console.log(this.materialList, 'this.materialList') 
        } else {
          this.$message.error(res.message)
        }
      })
    },

        // 查看
    detailFun(row) {
      // console.log(row,'000');
      
      this.dialogVisible = true
      this.rowMaterial = row
      this.getMaterialinfo(row)
    },

    // 原先
    // getMaterialinfo(row) {
    //   getMaterialById(row.materialId).then(res => {
    //     if (res.code === 1) {
    //       if (res.data.fileNames.length > 0) {
    //         this.fileNames = res.data.fileNames
    //         this.inItImages()
    //       }
    //     }
    //   })
    // },
    

    // inItImages() {
    //   this.fileNames.forEach(name => {
    //     console.log(name)
    //     const data = { fileName: name }
    //     getImgs(data).then(res => {
    //       const file = setInitImg(res, name)
    //       this.picList.push(file.url)
    //     })
    //   })
    // },

        // 修改
        getMaterialinfo(row) {
      getMaterialById(row.materialId).then(res => {
        if (res.code === 1) {
          if (res.data.fileNames.length > 0) {
            this.fileNames = res.data.fileNames
            this.inItImages(row)
          }
        }
      })
    },
    

    inItImages(row) {
  if (!this.fileNames || this.fileNames.length === 0) 
      return;
  // 临时数组存储新图片
  const newPics = [];
  this.fileNames.forEach(name => {
    const data = {
      fileName: name,
      materialCode: row.materialCode // 使用当前行的materialCode
    }
    getImgs(data).then(res => {
      const file = setInitImg(res, name)
      // 检查是否已存在
      if (!this.picList.some(p => p.name === file.name)) {
        newPics.push(file);
      }
      // 当所有图片处理完成
      if (newPics.length === this.fileNames.length) {
        this.picList = [...newPics]; // 替换整个数组
      }
      this.saveLoad = false;
    })
  })
  },
    // ----获取物料审批流程--
    viewApproveDetail() {
      const param = {
        orderId: this.$route.query.applyOrderId || ''
      }
      this.approveLoading = true
      const done = (data) => {
        this.findHistTasksData = data || []
        // 填充审核人信息（如果审核部门不为空但审核人为空）
        if (Array.isArray(this.findHistTasksData)) {
          this.findHistTasksData.forEach(item => {
            if (item.displayName && !item.operatorName && this.order.applyAuditorNames) {
              item.operatorName = this.order.applyAuditorNames
              item.finishTime = '正在处理'
            }
          })
        }
        this.fillApproveInfoFromHistory()
        // 审批历史返回后也尝试一次姓名兜底
        // this.ensureReceiverName()
        this.approveLoading = false
      }
      if (this.$route.query.orderStatus === '6') {
        findDisTaskInfos(param).then(res => done(res.data))
      } else {
        findTaskInfos(param).then(res => {
          if (res.code === 1 && res.data) done(res.data)
        })
      }
    },

    close() {
      this.dialogVisible = false
      this.picList = []
    },
    returnFun() {
      this.returnListFun()
    },
    returnListFun() {
      if(this.$route.query.type === 'myToDolistGuangXuan'){
        // 跳转路由
        this.$closePage('/publicizeMaterialManagement/applyOrderDetail', '/publicizeMaterialManagement/myToDolist')
      }else if(this.$route.query.type === 'myToDolistShiChang'){
        // 跳转路由
        this.$closePage('/publicizeMaterialManagement/applyOrderDetail', '/terminalActivity/myToDolist')
      }
      else {
        // 跳转路由
        this.$closePage('/publicizeMaterialManagement/applyOrderDetail', '/publicizeMaterialManagement/advertiseMaterialRequisition')
      }
    },
  }
}
</script>
<style lang="less" scoped>
.orderFormLine {
  margin: 0;
  padding: 0px 20px;
  width: 100%;
  background: #0a76a4;
  color: #ffffff;
  height: 30px;
  line-height: 30px;
}

.order-btn {
  margin-top: 0px;
}
.collapseItem {
  /deep/ .el-collapse-item__header {
    padding: 0px 20px;
    width: 100%;
    margin: 0;
    background: #0a76a4;
    color: #ffffff;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
  }
  /deep/ .el-collapse-item__content {
    padding-top: 20px;
    padding-right: 20px;
  }
}
.ant-divider-horizontal {
  display: block;
  clear: both;
  width: 100%;
  min-width: 100%;
  height: 1px;
  margin: 5px 0;
}
</style>
